let OrderListCtrl = function($scope, $state, $stateParams, gettextCatalog, items, Notification, $sessionStorage, ModalService) {
  let self = this;
  this.items = items;
  this._state = $state;
  this.gettextCatalog = gettextCatalog;
  this._Notification = Notification;
  this._sessionStorage = $sessionStorage.$default({
    items: [],
    deliveryType: 'shipping'
  });
  this.orderedItems = this._sessionStorage.items;
  let ersatzteile = gettextCatalog.getString('Ersatzteile');
  this.filter = {
    name: '',
    number: ''
  };
  this.type = $stateParams.type;
  this._ModalService = ModalService;

  if(this.type === 'scooter') {
    this.filteredItems = this.items.filter((item) => item.type === 'scooter');
  } else if(this.type === 'part') {
    this.filteredItems = this.items.filter((item) => item.type === 'part');
  } else {
    this.filteredItems = [];
  }

  $scope.$watch(function() {
    return self.filter;
  }, (newValue, oldValue) => {
    let filter = {};

    if(newValue === oldValue) {
      return;
    }

    if (self.filterScooter) {
      filter.article_group_id = self.filterScooter;
    } else if (self.filteParts) {
      filter.article_group_id = self.filteParts;
    }

    if (newValue.name) {
      filter.intern_name = newValue.name;
    }

    if (newValue.number) {
      filter.intern_code = newValue.number;
    }

    this.filteredItems = self.items.filter(item => {
      if (filter.article_group_id && item.article_group_id !== filter.article_group_id) {
        return false;
      }

      if(filter.intern_name && filter.intern_code) {
        return item.intern_name.indexOf(filter.intern_name) > -1 && item.intern_code.indexOf(filter.intern_code) > -1;
      } else if (filter.intern_name) {
        return item.intern_name.indexOf(filter.intern_name) > -1;
      } else if (filter.intern_code) {
        return item.intern_code.indexOf(filter.intern_code) > -1;
      } else{
        return true;
      }
    });
  }, true);

  this.parts = [
    {label: `${ersatzteile} E-Jeek`, id: 3},
    {label: `${ersatzteile} E-Mine`, id: 4},
    {label: `${ersatzteile} Emofa`, id: 19},
    {label: `${ersatzteile} Emofa 320`, id: 6},
    {label: `${ersatzteile} Emofa 330`, id: 5},
    {label: `${ersatzteile} Emofa 3XX`, id: 12}
  ];

  this.scooter = [
    {label: 'E-Business', id: 17},
    {label: 'E-Business-Power', id: 18},
    {label: 'E-Climber', id: 14},
    {label: 'E-Cruiser', id: 30},
    {label: 'E-Delivery', id: 31},
    {label: 'E-Falcon', id: 35},
    {label: 'E-Fun', id: 29},
    {label: 'E-Jeek', id: 9},
    {label: 'E-Kelly', id: 28},
    {label: 'E-Liberty', id: 36},
    {label: 'E-Mine', id: 8},
    {label: 'E-Rider', id: 39},
    {label: 'E-Sporty', id: 37},
    {label: 'E-Start', id: 32},
    {label: 'E-Stream', id: 38},
    {label: 'E-Töffli Power', id: 34},
    {label: 'E-Töffli', id: 33},
    {label: 'E-Young', id: 16},
    {label: 'Emofa 300', id: 13},
    {label: 'Emofa 320', id: 11},
    {label: 'Emofa 330', id: 10}
  ];

  this.gridOptions = {
    data: this.filteredItems,
    enableFiltering: true,
    onRegisterApi: function(gridApi) {
      self.gridApi = gridApi
    },
    columnDefs: [
      {
        field: 'intern_name',
        enableColumnMenu: false,
        displayName: gettextCatalog.getString('Art.-Name')
      },
      {
        field: 'intern_code',
        enableColumnMenu: false,
        displayName: gettextCatalog.getString('Art.-Nummer')
      },
      {
        field: 'sale_price',
        enableColumnMenu: false,
        enableFiltering: false,
        maxWidth: 150,
        displayName: gettextCatalog.getString('Händlerpreis')
      },
      {
        field: 'intern_description',
        enableColumnMenu: false,
        enableFiltering: false,
        displayName: gettextCatalog.getString('Verkaufspreis Endkunde'),
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="row.entity[col.field]"></div>',
        minWidth: 400
      },
      {
        field: 'stock_available_nr',
        enableColumnMenu: false,
        enableFiltering: false,
        displayName: gettextCatalog.getString('Lagerbestand'),
        maxWidth: 120
      },
      {
        field: 'id',
        enableColumnMenu: false,
        displayName: gettextCatalog.getString('Bestellen'),
        enableFiltering: false,
        maxWidth: 120,
        cellTemplate: '<div class="ui-grid-cell-contents text-center" data-ng-click="grid.appScope.OrderListCtrl.add(row.entity)"><span class="dripicons-cart" aria-hidden="true" data-icon></span></div>'
      }
    ]
  };
};

OrderListCtrl.prototype.updateFilter = function(type) {
  if (type === 'scooter') {
    this.filteParts = null;
    this.filteredItems = _.filter(this.items, {article_group_id: this.filterScooter});
  } else if (type === 'part') {
    this.filterScooter = null;
    this.filteredItems = _.filter(this.items, {article_group_id: this.filteParts});
  }
};

OrderListCtrl.prototype.getName = function(item) {
  var nameParts = item.intern_name ? item.intern_name.split('/') : [];
  return nameParts.length ? nameParts[0] : item.intern_name;
};

OrderListCtrl.prototype.add = function(item) {
  let self = this;
  let cartItem = _.find(this._sessionStorage.items, {id: item.id});
  this._Notification.success(this.gettextCatalog.getString('{{menge}} x {{artikel}} hinzugefügt', {menge: item.order_number, artikel: item.intern_name}));

  if (!cartItem) {
    this._sessionStorage.items.push(angular.copy(item));
  } else {
    cartItem.order_number += item.order_number;
  }

  item.order_number = 1;

  this._ModalService.showModal({
    templateUrl: "https://order.emofa.ch/app/modules/order/YesNoModalView.html",
    controller: "YesNoController as YesNoController"
  }).then(function(modal) {
    modal.element.modal();
    modal.close.then(function(result) {
      if(result) {
        self._state.go('app.shipment');
      }
    });
  });
};

OrderListCtrl.prototype.changeAmount = function(item, amount) {
  item.order_number += amount;

  if (amount === 1) {
    item.order_number = Math.min(item.order_number, item.stock_available_nr);
  } else if (amount === -1) {
    item.order_number = Math.max(item.order_number, 1);
  }
};

module.exports = OrderListCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/order/OrderListCtrl.js